<template>
  <scanSimpleInput
    v-bind="$attrs"
    class="pg-scan-add-medical"
    @on-change="scanSimpleChange"
    :disabled="disabled"
  ></scanSimpleInput>
</template>
<script setup>
// hook
import { scanSimpleInput } from '../../../../pangu-components/components/scanNumber/index'
import { useFlashAddMedical } from '../hook/use-flash-add'

// utils
import { setValueByPath } from '../../../utils/index'

const props = defineProps({
  requestParams: Object,
  disabled: Boolean,
})

const emit = defineEmits([])
// 获取公共方法
const { emitComponentData } = useFlashAddMedical(emit)

const scanSimpleChange = (data) => {
  let parameters = {
    ...props.requestParams?.parameters,
  }
  setValueByPath(parameters, 'codes', [data.code])
  emitComponentData({
    data,
    originData: data,
    type: 'scanAdd',
    parameters: { ...props.requestParams, parameters },
  })
}
</script>
<style lang="scss">
@import '../style/scan-add-medical.scss';
</style>
